import graphql from 'graphql-tag'
import client from '@stores/apollo'
import handleFetchResult from '@utils/handleFetchResult'
import { ITag } from '@api/types'

interface IPayload {
  createTags: {
    tags: ITag[]
  }
}

const mutateHandler = handleFetchResult<IPayload, ITag>({
  handler: (data) => data.createTags.tags[0],
  name: 'Spaces',
})

export default function create(name: string) {
  return client.gql.mutate({ mutation, variables: { input: { tags: [name] } } }).then(mutateHandler)
}

const mutation = graphql`
  mutation createTags($input: CreateTagsMutationInput!) {
    createTags(input: $input) {
      tags {
        id
        name
      }
    }
  }
`
